<template>
  <div class="payment-apis">
    <div v-show="!failedPayment">
      <div class="form-field">
        <input
          id="card-holder-name"
          name="card-holder-name"
          aria-label="Card holder name"
          v-model="cardHolderName"
          type="text"
          placeholder="Card holder name"
          ref="cardHolderName"
          v-validate="'required'"
          :class="{'input-error': errors.has('cardHolderName')}"
        />
      </div>

      <div class="form-field">
        <div id="card-number" :class="{ 'input-error': cardNumberError }"></div>
      </div>

      <div class="cvv-form-field">
        <div id="card-expiry" :class="{ 'input-error': cardExpiryError }"></div>
        <div id="card-cvv" :class="{ 'input-error': cardCVVError }"></div>
      </div>
    </div>

    <div class="errors" v-if="cardNumberError || cardCVVError || cardExpiryError || serverError">
      <label for="card-number" id="card-number-error">{{ cardNumberError }}</label>
      <label for="card-cvv" id="card-cvv-error">{{ cardCVVError }}</label>
      <label for="card-expiry" id="card-expiry-error">{{ cardExpiryError }}</label>
      <label
        v-if="errors.has('cardHolderName')"
        for="card-holder-name"
        id="card-holder-name-error"
      >Card holder name incorrect</label>
      <label>{{ serverError }}</label>
    </div>

    <div class="form-buttons" v-if="!failedPayment">
      <button
        type="button"
        class="pay-now"
        :class="{ 'disabled': !activatePayButton() }"
        :disabled="!activatePayButton()"
        href="#form-top"
        data-animation-duration="300"
        data-animation-easing="swing"
        id="pay-button"
        @click="Pay"
        data-smooth-scroll
        data-threshold="75"
      >{{ submitButtonMessage }}</button>
    </div>

    <div class="form-buttons" v-if="failedPayment">
      <button
        type="button"
        class="pay-now"
        href="#form-top"
        data-animation-duration="300"
        data-animation-easing="swing"
        id="retry-button"
        @click="retry"
        data-smooth-scroll
        data-threshold="75"
      >Retry</button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "VueBamboraCustomCheckout",
  data() {
    return {
      isCardNumberComplete: false,
      isCVVComplete: false,
      isExpiryComplete: false,
      isPayButtonDisabled: false,
      customCheckout: customcheckout(),
      cardHolderName: "",
      cardHolderNameError: undefined,
      cardNumberError: undefined,
      cardCVVError: undefined,
      cardExpiryError: undefined,
      serverError: undefined,
      bamboraInputs: {
        cardNumber: undefined,
        expiryTime: undefined,
        cvvNumber: undefined,
      },
      failedPayment: false,
    };
  },
  props: {
    submitButtonMessage: {
      type: String,
      default: "Pay Now",
    },
  },
  mounted() {
    this.initForm();
    this.initCustomeCheckoutEvents();
  },
  computed: mapState({
    donation: (state) => state.donation.donation,
  }),
  methods: {
    initForm: function () {
      // Set the font size for the inputs inside the injected iframes
      let style = {
        base: {
          fontSize: "15px",
        },
      };
      var options = {
        style,
      };

      this.cardHolderName = "";

      // Create and mount the inputs
      options.placeholder = "Card number";
      this.bamboraInputs.cardNumber = this.customCheckout.create(
        "card-number",
        options
      );
      this.bamboraInputs.cardNumber.mount("#card-number");

      options.placeholder = "CVV / CVC";
      this.bamboraInputs.cvvNumber = this.customCheckout.create("cvv", options);
      this.bamboraInputs.cvvNumber.mount("#card-cvv");

      options.placeholder = "MM / YY";
      this.bamboraInputs.expiryTime = this.customCheckout.create(
        "expiry",
        options
      );
      this.bamboraInputs.expiryTime.mount("#card-expiry");
    },
    initCustomeCheckoutEvents: function () {
      this.customCheckout.on("empty", (event) => {
        if (event.empty) {
          if (event.field === "card-number") {
            this.ToggleCardNumberComplete(false);
          } else if (event.field === "cvv") {
            this.ToggleCVVComplete(false);
          } else if (event.field === "expiry") {
            this.ToggleExpiryComplete(false);
          }
        }
      });

      this.customCheckout.on("error", (event) => {
        if (event.field === "card-number") {
          console.log("Card number has errors: ", event);
          this.cardNumberError = event.message;
        } else if (event.field === "cvv") {
          console.log("CVV has errors: ", event);
          this.cardCVVError = event.message;
        } else if (event.field === "expiry") {
          console.log("Expiry has errors: ", event);
          this.cardExpiryError = event.message;
        }
      });

      // Display card brand logo in the card number input
      this.customCheckout.on("brand", (event) => {
        let cardLogo = "none";
        if (event.brand && event.brand !== "unknown") {
          let filePath = `https://cdn.na.bambora.com/downloads/images/cards/${event.brand}.svg`;
          cardLogo = "url(" + filePath + ")";
        }
        document.getElementById("card-number").style.backgroundImage = cardLogo;
      });

      this.customCheckout.on("complete", (event) => {
        if (event.field === "card-number") {
          this.cardNumberError = undefined;
          this.serverError = "";
          this.ToggleCardNumberComplete(true);
          console.log("Card number is complete: ", event);
        } else if (event.field === "cvv") {
          this.ToggleCVVComplete(true);
          this.serverError = "";
          this.cardCVVError = undefined;
          console.log("CVV is complete: ", event);
        } else if (event.field === "expiry") {
          this.ToggleExpiryComplete(true);
          this.cardExpiryError = undefined;
          this.serverError = "";
          console.log("Expiry is complete: ", event);
        }
      });
    },
    resetForm: function () {
      this.bamboraInputs.expiryTime.clear();
      this.bamboraInputs.cardNumber.clear();
      this.bamboraInputs.cvvNumber.clear();
      this.cardHolderName = "";

      // No need to reset the "complete" flags. In case of copy paste of a good card, the "complete" trigger won't fire.
      // If the user enter a wrong card number, the "error" trigger will fire anyway.
      // Trying to pay with empty field will just fail the payment.

      document.getElementById("card-number").style.backgroundImage = "";
    },
    resetFormErrors: function () {
      this.cardNumberError = undefined;
      this.cardCVVError = undefined;
      this.cardExpiryError = undefined;
      this.serverError = undefined;
      this.cardHolderName = "";
    },
    TogglePayButtonDisabled: function (value) {
      //disable pay-button
      this.isPayButtonDisabled = value;
    },
    cardHolderNameIsValid: function () {
      return this.cardHolderName && this.cardHolderName.length > 3
        ? true
        : false;
    },
    activatePayButton: function () {
      // Activate Pay Button only if all the field are complete and there is no errors
      return (
        this.isCardNumberComplete &&
        this.isExpiryComplete &&
        this.isCVVComplete &&
        !this.cardNumberError &&
        !this.cardCVVError &&
        !this.cardExpiryError &&
        !this.serverError &&
        this.cardHolderNameIsValid() &&
        !this.isPayButtonDisabled
      );
    },
    ToggleCardNumberComplete: function (value) {
      this.isCardNumberComplete = value;
    },
    ToggleCVVComplete: function (value) {
      this.isCVVComplete = value;
    },
    ToggleExpiryComplete: function (value) {
      this.isExpiryComplete = value;
    },
    Pay: function () {
      this.TogglePayButtonDisabled(true);
      console.log("Pay::customCheckout.createOneTimeToken()");
      this.customCheckout.createOneTimeToken(
        wwfconfigs.MERCHANTID,
        this.processToken
      );
    },
    processToken: function (result) {
      console.log("token result : ", result);
      if (result.error) {
        this.processTokenError(result.error);
      } else {
        this.processTokenSuccess(result.token);
      }
    },
    processTokenError: function (error) {
      console.log("processTokenError: ", error);
      if (error.message) {
        this.serverError = error.message;
      } else {
        this.serverError = 'Unable to process transaction. Please try again later.';
      }
      this.TogglePayButtonDisabled(false);
      this.failedPayment = true;
    },
    processTokenSuccess: function (token) {
      console.log("processTokenSuccess: " + token);
      this.serverError = undefined;

      this.$emit("success", {
        token,
        cardHolderName: this.cardHolderName,
      });
    },
    retry() {
      this.$emit("retry");
      this.resetForm();
      this.resetFormErrors();
    },
    reset: function (error) {
      this.resetForm();
      if (error) {
        this.serverError = error;
        this.failedPayment = true;
      } else {
        this.resetFormErrors();
        this.failedPayment = false;
      }
      this.TogglePayButtonDisabled(false);
    },
  },
};
</script>

<!-- This Style need to be not scoped ! -->
<style>
.wwf-form #Step3 .payment-apis iframe {
  height: 15px;
}
</style>

<style scoped>
.cvv-form-field {
  display: flex;
  flex-direction: row;
}

#card-holder-name,
#card-number,
#card-cvv,
#card-expiry {
  background-color: var(--wwfWhite);
  display: block;
  border: 1px solid var(--wwfGreyC8);
  padding: 14px 60px 13px 20px;
  margin: auto;
  transition: all 100ms ease-out;
  background-color: var(--wwfTransparentBlack005);
}

#card-holder-name:focus {
  box-shadow: inset 0 0 0 2px var(--primaryColor);
}

#card-number.bambora-checkoutfield-focus,
#card-cvv.bambora-checkoutfield-focus,
#card-expiry.bambora-checkoutfield-focus {
  box-shadow: inset 0 0 0 2px var(--primaryColor);
}

#card-holder-name {
  margin-bottom: 30px;
  height: 53px;
}

#card-holder-name,
#card-number {
  margin-top: 5px;
  border-radius: 2px 2px 0 0;
  background-image: none;
  background-origin: content-box;
  background-position: calc(100% + 40px) center;
  background-repeat: no-repeat;
  background-size: contain;
}

#card-holder-name::-webkit-input-placeholder {
  font: 500 15px Arial !important;
  color: #555 !important;
}

#card-cvv {
  border-bottom-right-radius: 2px;
  border-top: none;
  border-left: none;
}

#card-expiry {
  border-bottom-left-radius: 2px;
  border-top: none;
}

#card-cvv,
#card-expiry {
  width: 100%;
  display: inline-block;
  margin-bottom: 30px;
}

.payment-apis .pay-now {
  text-transform: initial;
  font-size: 15px;
  line-height: 24px;
  height: auto;
  background-color: var(--primaryColor) !important;
}

.payment-apis .pay-now.disabled {
  cursor: default;
  background-color: var(--wwfGreyDE) !important;
}

.errors {
  margin-bottom: 20px;
}

.errors label {
  font-size: 15px;
  color: var(--errorColor);
  display: block;
}

.payment-apis .input-error {
  border: 2px solid var(--errorColor) !important;
}
</style>



// WEBPACK FOOTER //
// VueBamboraCustomCheckout.vue?d42e1ed4